export const TIMEZONE_LABELS = {
  'International Date Line West': 'Etc/GMT+12',
  'American Samoa': 'Pacific/Pago_Pago',
  'Midway Island': 'Pacific/Midway',
  Hawaii: 'Pacific/Honolulu',
  Alaska: 'America/Anchorage',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  Tijuana: 'America/Tijuana',
  Arizona: 'America/Phoenix',
  'Mountain Time (US & Canada)': 'America/Denver',
  Mazatlan: 'America/Mazatlan',
  'Central Time (US & Canada)': 'America/Chicago',
  'Central America': 'America/Guatemala',
  Chihuahua: 'America/Chihuahua',
  'Mexico City': 'America/Mexico_City',
  Monterrey: 'America/Monterrey',
  Saskatchewan: 'America/Regina',
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  Bogota: 'America/Bogota',
  Lima: 'America/Lima',
  Panama: 'America/Panama',
  Quito: 'America/Guayaquil',
  'Atlantic Time (Canada)': 'America/Halifax',
  Caracas: 'America/Caracas',
  Georgetown: 'America/Guyana',
  'La Paz': 'America/La_Paz',
  'Puerto Rico': 'America/Puerto_Rico',
  Newfoundland: 'America/St_Johns',
  Santiago: 'America/Santiago',
  Brasilia: 'America/Sao_Paulo',
  'Buenos Aires': 'America/Argentina/Buenos_Aires',
  Montevideo: 'America/Montevideo',
  Greenland: 'America/Nuuk',
  'Mid-Atlantic': 'Etc/GMT+2',
  Azores: 'Atlantic/Azores',
  'Cape Verde Is.': 'Atlantic/Cape_Verde',
  Casablanca: 'Africa/Casablanca',
  Dublin: 'Europe/Dublin',
  Lisbon: 'Europe/Lisbon',
  London: 'Europe/London',
  Monrovia: 'Africa/Monrovia',
  UTC: 'Etc/UTC',
  Amsterdam: 'Europe/Amsterdam',
  Belgrade: 'Europe/Belgrade',
  Berlin: 'Europe/Berlin',
  Bratislava: 'Europe/Bratislava',
  Brussels: 'Europe/Brussels',
  Budapest: 'Europe/Budapest',
  Copenhagen: 'Europe/Copenhagen',
  Ljubljana: 'Europe/Ljubljana',
  Madrid: 'Europe/Madrid',
  Paris: 'Europe/Paris',
  Prague: 'Europe/Prague',
  Rome: 'Europe/Rome',
  Sarajevo: 'Europe/Sarajevo',
  Skopje: 'Europe/Skopje',
  Stockholm: 'Europe/Stockholm',
  Vienna: 'Europe/Vienna',
  Warsaw: 'Europe/Warsaw',
  'West Central Africa': 'Africa/Lagos',
  Zagreb: 'Europe/Zagreb',
  Zurich: 'Europe/Zurich',
  Athens: 'Europe/Athens',
  Bucharest: 'Europe/Bucharest',
  Cairo: 'Africa/Cairo',
  Harare: 'Africa/Harare',
  Helsinki: 'Europe/Helsinki',
  Jerusalem: 'Asia/Jerusalem',
  Kaliningrad: 'Europe/Kaliningrad',
  Kyiv: 'Europe/Kyiv',
  Pretoria: 'Africa/Johannesburg',
  Riga: 'Europe/Riga',
  Sofia: 'Europe/Sofia',
  Tallinn: 'Europe/Tallinn',
  Vilnius: 'Europe/Vilnius',
  Baghdad: 'Asia/Baghdad',
  Istanbul: 'Europe/Istanbul',
  Kuwait: 'Asia/Kuwait',
  Minsk: 'Europe/Minsk',
  Moscow: 'Europe/Moscow',
  Nairobi: 'Africa/Nairobi',
  Riyadh: 'Asia/Riyadh',
  Volgograd: 'Europe/Volgograd',
  Tehran: 'Asia/Tehran',
  'Abu Dhabi': 'Asia/Dubai',
  Baku: 'Asia/Baku',
  Muscat: 'Asia/Muscat',
  Samara: 'Europe/Samara',
  Tbilisi: 'Asia/Tbilisi',
  Yerevan: 'Asia/Yerevan',
  Kabul: 'Asia/Kabul',
  Almaty: 'Asia/Almaty',
  Ekaterinburg: 'Asia/Yekaterinburg',
  Karachi: 'Asia/Karachi',
  Tashkent: 'Asia/Tashkent',
  Kolkata: 'Asia/Kolkata',
  'Sri Jayawardenepura': 'Asia/Colombo',
  Kathmandu: 'Asia/Kathmandu',
  Dhaka: 'Asia/Dhaka',
  Urumqi: 'Asia/Urumqi',
  Rangoon: 'Asia/Yangon',
  Bangkok: 'Asia/Bangkok',
  Hanoi: 'Asia/Ho_Chi_Minh',
  Jakarta: 'Asia/Jakarta',
  Krasnoyarsk: 'Asia/Krasnoyarsk',
  Novosibirsk: 'Asia/Novosibirsk',
  Beijing: 'Asia/Shanghai',
  'Hong Kong': 'Asia/Hong_Kong',
  Irkutsk: 'Asia/Irkutsk',
  'Kuala Lumpur': 'Asia/Kuala_Lumpur',
  Perth: 'Australia/Perth',
  Singapore: 'Asia/Singapore',
  Taipei: 'Asia/Taipei',
  Ulaanbaatar: 'Asia/Ulaanbaatar',
  Seoul: 'Asia/Seoul',
  Tokyo: 'Asia/Tokyo',
  Yakutsk: 'Asia/Yakutsk',
  Darwin: 'Australia/Darwin',
  Adelaide: 'Australia/Adelaide',
  Brisbane: 'Australia/Brisbane',
  Guam: 'Pacific/Guam',
  'Port Moresby': 'Pacific/Port_Moresby',
  Hobart: 'Australia/Hobart',
  Melbourne: 'Australia/Melbourne',
  Sydney: 'Australia/Sydney',
  Magadan: 'Asia/Magadan',
  'New Caledonia': 'Pacific/Noumea',
  'Solomon Is.': 'Pacific/Guadalcanal',
  Srednekolymsk: 'Asia/Srednekolymsk',
  Fiji: 'Pacific/Fiji',
  Kamchatka: 'Asia/Kamchatka',
  'Marshall Is.': 'Pacific/Majuro',
  Auckland: 'Pacific/Auckland',
  'Chatham Is.': 'Pacific/Chatham',
  "Nuku'alofa": 'Pacific/Tongatapu',
  Samoa: 'Pacific/Apia',
  'Tokelau Is.': 'Pacific/Fakaofo',
}

export const DEFAULT_TIMEZONE = 'America/New_York'
